import clsx from "clsx";
import { FC, useEffect, useState } from "react";
import s from "./styles.module.sass";

export type SelectOption = {
	id: number;
	title: string;
};

type Select = {
	selectedOption: number;
	options: SelectOption[];
	disabled?: boolean;
	onSelect: (id: number) => void;
};

const Select: FC<Select> = ({ selectedOption, options, disabled, onSelect }) => {
	const [isOptionsOpened, setIsOptionsOpened] = useState(false);
	const [localSelectedOption, setLocalSelectedOption] = useState(selectedOption);
	useEffect(() => {
		setLocalSelectedOption(selectedOption);
	}, [selectedOption]);

	const hadleToggleOptions = () => {
		setIsOptionsOpened(!isOptionsOpened);
	};

	const handleChooseOption = (id: number) => {
		setLocalSelectedOption(id);
		onSelect(id);
		setIsOptionsOpened(false);
	};

	return (
		<div className={s.selectWrapper}>
			<button
				className={clsx(s.selectButton, {
					[s.disabled]: disabled,
				})}
				type="button"
				disabled={disabled}
				onClick={hadleToggleOptions}
			>
				<p>
					{
						options.find((option) => {
							return option.id === localSelectedOption;
						})?.title
					}
				</p>
				<div
					className={clsx(s.expandIcon, {
						[s.opened]: isOptionsOpened,
					})}
				/>
			</button>
			<ul
				className={clsx(s.options, {
					[s.opened]: isOptionsOpened,
				})}
				tabIndex={-1}
			>
				{options.map((option) => {
					return (
						<li key={option.id} className={s.option}>
							<button
								onClick={() => {
									return handleChooseOption(option.id);
								}}
								className={s.optionButton}
							>
								{option.title}
							</button>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export default Select;
